var map = {
	"./de/milestones.json": 725,
	"./en/milestones.json": 7089,
	"./es/milestones.json": 2948,
	"./fr/milestones.json": 8492,
	"./hu/milestones.json": 9385,
	"./it/milestones.json": 331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;